import script from "./CommonMenuAside.vue?vue&type=script&setup=true&lang=js"
export * from "./CommonMenuAside.vue?vue&type=script&setup=true&lang=js"

import "./CommonMenuAside.vue?vue&type=style&index=0&id=e412ddea&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e412ddea"]])

export default __exports__